/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { Dropdown } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import * as AppConstants from '../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../assets/images/commen-visible-icon.svg';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  URASoruceHead,
  URACalcHead,
  URAPaymentHead,
  InterestCalcHead,
  FederalFamilyHead,
  FederalPercentHead,
} from './tablehead';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
} from '../../../SharedModules/utilities/utilities';
import { closeTab } from '../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../SharedModules/Dialog/CommonModal';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { redirectURLLink } from '../../../SharedModules/CommonUtilities/commonUtilities';
import ViewHistoryComponent from '../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { getCheckPay } from './store/actions';

const URATab = (props) => {
  const dispatch = useDispatch();
  const {
    gridData,
    frozenQtr,
    frameworkComponents,
    uraSourceAdd,
    uraCalcFrameworkComponents,
    payFrameworkComponent,
    uraRecordDelete,
    handleFullScreen,
    disableUTAPayAdd,
    isEnablebyRole,
  } = props;
  const ura_source = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.ura_source
  );
  const ura_calc = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.ura_calc
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const [srcGrid, setSrcGrid] = React.useState();
  const [calcGrid, setCalcGrid] = React.useState();
  const [payGrid, setPayGrid] = React.useState();
  const [sourceData, setSourceData] = React.useState([]);
  const [calcData, setCalcData] = React.useState([]);
  const [payData, setPayData] = React.useState([]);
  const [disableCalcAdd, setDisableCalcAdd] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [deleteMsg, setDeleteMsg] = React.useState('');
  const [srcFullscreen, setSrcFullScreen] = React.useState(false);
  const [calcFullscreen, setCalcFullScreen] = React.useState(false);
  const [payFullscreen, setPayFullScreen] = React.useState(false);

  const onSrcGridReady = (params) => {
    setSrcGrid(params);
  };
  const onCalcGridReady = (params) => {
    setCalcGrid(params);
  };
  const onPayGridReady = (params) => {
    setPayGrid(params);
  };

  React.useEffect(() => {
    if (gridData) {
      let { rpcUraSource, rpcUraCal, rpcUrPayment } = gridData;
      if (rpcUraSource) {
        setSourceData([...rpcUraSource]);
        if (
          rpcUraSource.filter((obj) => obj.rpcParamValue === 'CALC').length > 0
        )
          setDisableCalcAdd(false);
        else setDisableCalcAdd(true);
      }
      if (rpcUraCal) setCalcData([...rpcUraCal]);
      if (rpcUrPayment) setPayData([...rpcUrPayment]);
    }
  }, [gridData]);

  React.useEffect(() => {
    if (!ura_source) dispatch(getCheckPay('URA_SOURCE_CD'));
    if (!ura_calc) dispatch(getCheckPay('URA_CALC_METHOD_CD'));
  }, []);

  return (
    <>
      {!calcFullscreen && !payFullscreen && (
        <fieldset
          data-testid='urasourcefieldset'
          className='custom-fieldset mt-3'
          style={{ height: 'auto' }}
        >
          <legend className='same-font-family'>
            URA Source <span className='mandatory'> *</span>
          </legend>
          {/* {!srcFullscreen && (
            <div className="btn-wrapper mb-2">
              <div className="float-right">
                <Buttondata
                  className="btn btn-success"
                  onClick={() => uraSourceAdd('src')}
                >
                  <SVGComponent iconName="Icon-outline-add-circle1" /> Add
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => {
                    if (
                      sourceData.filter((o) => o.delete === true).length > 0
                    ) {
                      setDeleteModal(true);
                      setDeleteMsg('src');
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-cancel" /> Delete
                </Button>
              </div>
            </div>
          )} */}
          <div class='clearfix'></div>
          <div className='panel-body FRR-custom-table tbl-manufacturer-inner frr-rbtprg-tblselectbox'>
            <TableGrid
              data-testid='urasource'
              // rowData={sourceData}
              rowData={
                sourceData &&
                sourceData?.map((item) => {
                  const firstDropdownVal = ura_source?.filter((x) => {
                    return (
                      x.codeValueID &&
                      x.codeValueID?.codeValue === item.rpcParamValue
                    );
                  });
                  if (firstDropdownVal && firstDropdownVal.length > 0) {
                    item.uraSourceDD = `${
                      firstDropdownVal[0].codeValueID &&
                      firstDropdownVal[0].codeValueID.codeValue
                    } - ${firstDropdownVal[0].shortDescription}`;
                  } else {
                    item.uraSourceDD = null;
                  }
                  return item;
                })
              }
              gridHeight={srcFullscreen ? '70vh' : 360}
              gridCall={onSrcGridReady}
              noGlobalSort
              handleFullScreenViewClick={() => {
                setSrcFullScreen(!srcFullscreen);
                handleFullScreen(!srcFullscreen);
              }}
              addButtonText='Add URA Source'
              hideColumnsInPdf={['delete']}
              handleAddNewRow={
                isEnablebyRole ? (params, e) => uraSourceAdd('src') : ''
              }
              fullScreenView={srcFullscreen}
              columnDefs={URASoruceHead}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              exportFile
              fileName='URA Source'
              onCellFocused={onCellFocused}
              frameworkComponents={frameworkComponents}
              disableAddAction={!isEnablebyRole}
            />
          </div>
          <div className='clearfix' />
        </fieldset>
      )}
      {!srcFullscreen && !payFullscreen && (
        <fieldset className='custom-fieldset mt-3' style={{ height: 'auto' }}>
          <legend className='same-font-family'>URA Calculation</legend>
          {/* {!calcFullscreen && (
            <div className="btn-wrapper mb-2">
              <div className="float-right">
                <Button
                  className="btn btn-success"
                  onClick={() => uraSourceAdd('calc')}
                  disabled={disableCalcAdd}
                >
                  <SVGComponent iconName="Icon-outline-add-circle1" /> Add
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => {
                    if (calcData.filter((o) => o.delete === true).length > 0) {
                      setDeleteModal(true);
                      setDeleteMsg('calc');
                    }
                  }}
                  disabled={disableCalcAdd}
                >
                  <SVGComponent iconName="Icon-cancel" /> Delete
                </Button>
              </div>
            </div>
          )} */}
          <div class='clearfix' />
          <div className='panel-body FRR-custom-table tbl-manufacturer-inner  frr-rbtprg-tblselectbox'>
            <TableGrid
              data-testid='uracalculation'
              // rowData={calcData}
              rowData={
                calcData &&
                calcData?.map((item) => {
                  const firstDropdownVal = ura_calc?.filter((x) => {
                    return (
                      x.codeValueID &&
                      x.codeValueID?.codeValue === item.calcMethodCd
                    );
                  });
                  if (firstDropdownVal && firstDropdownVal.length > 0) {
                    item.uraCalcMethodDD = `${
                      firstDropdownVal[0].codeValueID &&
                      firstDropdownVal[0].codeValueID.codeValue
                    } - ${firstDropdownVal[0].shortDescription}`;
                  } else {
                    item.uraCalcMethodDD = null;
                  }
                  return item;
                })
              }
              noGlobalSort
              gridHeight={calcFullscreen ? '70vh' : 360}
              addButtonText='Add URA Calculation'
              handleAddNewRow={(e) => uraSourceAdd('calc')}
              disableAdd={disableCalcAdd}
              gridCall={onCalcGridReady}
              handleFullScreenViewClick={() => {
                setCalcFullScreen(!calcFullscreen);
                handleFullScreen(!calcFullscreen);
              }}
              hideColumnsInPdf={['delete']}
              fullScreenView={calcFullscreen}
              columnDefs={URACalcHead}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              exportFile
              fileName='URA Calculation'
              onCellFocused={onCellFocused}
              frameworkComponents={uraCalcFrameworkComponents}
            />
          </div>
          <div className='clearfix' />
        </fieldset>
      )}
      {!calcFullscreen && !srcFullscreen && (
        <fieldset className='custom-fieldset mt-3' style={{ height: 'auto' }}>
          <legend className='same-font-family'>Update URA From Payments</legend>
          {/* {!payFullscreen && (
            <div className="btn-wrapper mb-2">
              <div className="float-right">
                <Button
                  className="btn btn-success btn-search"
                  onClick={() => uraSourceAdd('pay')}
                >
                  <SVGComponent iconName="Icon-outline-add-circle1" /> Add
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => {
                    if (payData.filter((o) => o.delete === true).length > 0) {
                      setDeleteModal(true);
                      setDeleteMsg('pay');
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-cancel" /> Delete
                </Button>
              </div>
            </div>
          )} */}
          <div class='clearfix' />
          <div className='panel-body FRR-custom-table tbl-manufacturer-inner frr-rbtprg-tblselectbox'>
            <TableGrid
              data-testid='updateura'
              rowData={payData}
              gridHeight={payFullscreen ? '70vh' : 360}
              gridCall={onPayGridReady}
              noGlobalSort
              handleFullScreenViewClick={() => {
                setPayFullScreen(!payFullscreen);
                handleFullScreen(!payFullscreen);
              }}
              hideColumnsInPdf={['delete']}
              fullScreenView={payFullscreen}
              addButtonText='Add Update URA From Payments'
              handleAddNewRow={(e) => uraSourceAdd('pay')}
              columnDefs={URAPaymentHead}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              exportFile
              fileName='Update URA from Payment'
              onCellFocused={onCellFocused}
              frameworkComponents={payFrameworkComponent}
              disableAdd={disableUTAPayAdd}
            />
          </div>
          <div className='clearfix' />
        </fieldset>
      )}
      {/* <SaveCancelPopup
        open={deleteModal}
        data-test="cancelPopup"
        title="Delete"
        onConfim={() => {
          setDeleteModal(false);
          uraRecordDelete(deleteMsg);
        }}
        onCancel={(e) => setDeleteModal(false)}
        moduleName={`selected row(s)`}
      /> */}
    </>
  );
};

export default URATab;
